<template lang="pug">
  div.checkemail
    p.check_title {{$t('boundEmail')}}:
    p {{email}}
    van-button(class="back_btn", type="danger", block, round, @click="backPage") {{$t('return')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'CheckUser',
  data(){
    return{
      email: ''
    }
  },
  created(){
    this.email = this.$route.query.email
  },
  methods:{
    backPage(){
      this.$router.push({
        path: '/user/index'
      });
    }
  },
  computed:{
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
.checkemail{
  margin: 20px;
  p{
    margin: 5px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    &.check_title{
      margin-top: 50px;
      font-size: 12px;
      color: #c7c7c7;
    }
  }
  .back_btn{
        margin-top: 50px;
        width: 90%;
        left: 5%;
        padding: 15px;
  }
}
</style>